<button class="mobile-zus-button" (click)="navigateToHomeDg($event)">
  <div class="zus-content">
    <span class="zus-label">{{ 'akcja.rozliczenie-zus-podatki' | translate }}</span>
  </div>
</button>